// Типы экшенов в модуле
export enum DashboardAction {
  SetActiveDashboardTab = 'ACTIVE_DASHBOARD_TABLE',
  GetDashboardInfo = 'GET_DASHBOARD_INFO',
  GetDashboardAllInfo = 'GET_DASHBOARD_ALL_INFO',
  UpdateViewDashboard = 'UPDATE_VIEW_DASHBOARD',
  GetProgress = 'DASHBOARD/GET_PROGRESS'
}
